import { jsx } from "react/jsx-runtime";
import { IFrame } from "../../../components/IFrame/index.js";
function AdvertisingWindow(props) {
  const {
    url: baseUrl,
    testId = "advertising-window-root",
    product,
    language = "en",
    iframeProps = {},
    loadingErrorText,
    errorFallback,
    disabled,
    disabledPlaceholder,
    disabledPrefetch
  } = props;
  const host = globalThis.location?.host ?? "";
  const pathname = globalThis.location?.pathname ?? "";
  const hash = globalThis.location?.hash ?? "";
  const sourceInfo = `&host=${host}&pathname=${pathname}&hash=${hash}`;
  let url = `${baseUrl}?product=${product}&language=${language}${sourceInfo}`;
  switch (product) {
    case "PP": {
      const { ctx } = props;
      if (ctx) url = `${url}&ctx=${ctx}`;
      break;
    }
    case "RM": {
      const { ctx, role } = props;
      if (ctx) url = `${url}&ctx=${ctx}`;
      if (role) url = `${url}&role=${role}`;
      break;
    }
    default:
      break;
  }
  return /* @__PURE__ */ jsx(
    IFrame,
    {
      name: "login-advertising",
      testId,
      referrerPolicy: "no-referrer",
      loadingErrorText,
      errorFallback,
      disabled,
      disabledPlaceholder,
      disabledPrefetch,
      ...iframeProps,
      url
    }
  );
}
export {
  AdvertisingWindow
};
//# sourceMappingURL=AdvertisingWindow.js.map
